import React, { createContext, useContext, useState } from 'react';
import { TypeOfEtity } from '../model/enum/typeOfEntity';

const UserContext = createContext<any>(undefined);

const UserProvider = (props: any) => {
    //   const user = {} || JSON.parse(localStorage.getItem('user'))
    //   const setUser = useAuth().data.setUser

    //const _user = JSON.parse(localStorage.getItem('user') || '{}');
    const [user, setUser] = useState<any>({});
    const [isAdminApp, setIsAdminApp] = useState(false);
    const [tipEtiteta, setTipEtiteta] = useState(TypeOfEtity.Kategorija);
    const [selectedPitanje, setSelectedPitanje] = useState<any>(null);
    const [selectedPuskica, setSelectedPuskica] = useState<any>(null); // puskica koja se kreira ili se updateuje
    const [showSelectedPuskica, setShowSelectedPuskica] = useState(false); // uslov da se prikaze puskica za izmenu ili kreiranje nove puskice
    const [selectedPitanja, setSelectedPitanja] = useState<any>([]); // lista selektovanih pitanja za puskicu
    const [navLista, setNavLista] = useState<any>([]); //nav lista kod usera srednja lista koja podazuje dubinu odabranog podatka
    const [returnedList, setReturnedList] = useState([]); //user side bar lista
    const isSignedIn = !!user.email;

    return (
        <UserContext.Provider
            value={{
                user,
                setUser,
                isSignedIn,
                isAdminApp,
                setIsAdminApp,
                tipEtiteta,
                setTipEtiteta,
                selectedPitanje,
                setSelectedPitanje,
                showSelectedPuskica,
                setShowSelectedPuskica,
                selectedPuskica,
                setSelectedPuskica,
                selectedPitanja,
                setSelectedPitanja,
                navLista,
                setNavLista,
                returnedList,
                setReturnedList,
            }}
            {...props}
        />
    );
};

function useUser() {
    const context = useContext(UserContext);

    if (context === undefined) {
        throw new Error(`useUser must be used within a UserProvider`);
    }

    return context;
}

export { UserProvider, useUser };
